exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-title[data-v-06890e0f] {\n  font-weight: 500;\n  margin-top: 10px;\n  margin-bottom: 0;\n  color: #999;\n}\n.layout-item[data-v-06890e0f] {\n  padding: 0px;\n}\n.card-icon[data-v-06890e0f] {\n  background: #f53c3cc7 !important;\n}\n", ""]);

// exports
